// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgMigrationsController = function ($scope, $http, PgMigrations) {
    
    $scope.loading = true;

    $scope.migrationStatuses = [];

    const getEmptyFilter = function () {
        return {
            Status: null,
        };
    };

    $scope.filter = getEmptyFilter();

    $scope.loadPage = function () {
        $http.get('/api/v1/paymentGateway/migrations/statuses', {cache: true}).then(function (result) {
            $scope.migrationStatuses = result.data;
        });
    }

    $scope.loadPage();

    $scope.fetchMigrations = function () {
        const filter =
            {
                Statuses: [$scope.filter.Status],
            };
        $scope.loading = true;
        $scope.migrations = $scope.paginator(function(options, callback) {
                return PgMigrations.query(options, function()
                {
                    callback();
                    $scope.loading = false;
                });
            },
            filter,
            100);
    }

    $scope.fetchMigrations();

    $scope.resetFilter = function () {
        $scope.filter = getEmptyFilter();
    };
};
PgMigrationsController.$inject = ["$scope", "$http", "PgMigrations"];
